import callApi, { BaseResponse, BaseResponseDto, BaseResponsePagedDto } from "./baseRequest"

export enum HolidayType {
    Office = 1,
    Factory = 2
}

export enum HolidayCountry {
    BR = 'BR',
    AR = 'AR'
}

export enum Factories {
    CUBATAO = 'Cubatão',
    SANTO_ANDRE = 'Santo André',
    BHI_BCA = 'Bhi Bca'
}

export interface HolidayConfigurationDto {
    id: string
    country: HolidayCountry
    type: string
    description: string
    year: string
    value: string[]
    factory: string
}

const route = 'holiday-settings';

export function get(
    language: string,
    take: number,
    skip: number,
    search: string): Promise<BaseResponsePagedDto<HolidayConfigurationDto[]>> {
    const result: BaseResponsePagedDto<HolidayConfigurationDto[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: take,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi('GET', `${route}/${language}/list?take=${take}&skip=${skip}&search=${search}`)
        .then(response => {
            result.success = true;

            if (response.data) {
                result.data = response.data
                result.totalItems = response.totalItems
                result.totalPages = response.totalPages
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function upsert(item: HolidayConfigurationDto): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null
    };

    const response = callApi('POST', `${route}`, item)
        .then(response => {
            result.success = true;

            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function remove(id: string): Promise<BaseResponse> {
    const result: BaseResponse = {
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/delete/${id}`)
        .then(response => {
            result.success = true;
            return result;
        }).catch(err => {
            result.error = err.error;
            return result;
        });

    return response;
}